import {DG_Format_Money} from "../../../../format/money";
import React from "react";

const styleColor3 = {
    color: "#101828",
    fontWeight: 600,
}

const styleColor = {
    color: "#98A2B3",
    fontWeight: 400
}
export const mapMoneyMobile = (value) => {

    let money = value / 1000000000
    if (money > 1) {
        return (
            <>
                    <span style={{
                        ...styleColor3,
                        fontSize: 20
                    }}> {DG_Format_Money(money)}
                        <span style={{
                            ...styleColor,
                            fontSize: 14
                        }}> Tỷ </span>
                    </span>
            </>
        )
    } else {
        money = value / 1000000
        if (money > 1) {
            return (
                <>
                        <span style={{
                            ...styleColor3,
                            fontSize: 20
                        }}> {DG_Format_Money(money)}
                            <span style={{
                                ...styleColor,
                                fontSize: 14
                            }}> Triệu </span>
                        </span>
                </>
            )
        }
    }

    return (
        <>
                <span style={{
                    ...styleColor3,
                    fontSize: 20
                }}> {DG_Format_Money(value)}
                    <span style={{
                        ...styleColor,
                        fontSize: 14
                    }}> (VNĐ) </span>
                </span>
        </>
    )

}
